<template>
  <el-container class="stripe-wallet-widget">
    <div class="stripe-wallet-widget__header">
      <div
        class="stripe-wallet-widget__header__image"
        :style="{ backgroundImage: manageLogoUrl }"
      />
      <div class="stripe-wallet-widget__header__title">
        <span
          class="stripe-wallet-widget__header__title__property"
          v-text="currentManage.property.name"
        />
        <app-i18n
          class="stripe-wallet-widget__header__title__subproperty"
          code="entities.propertyWallet.list.wallet"
          :args="[currentManage.subproperty.name]"
        />
      </div>
      <div
        v-if="connectedAccount"
        class="stripe-wallet-widget__header__payout"
      >
        <app-i18n
          class="stripe-wallet-widget__header__payout__title"
          code="entities.propertyWallet.title.payout"
        />

        <template v-if="payoutsScheduleInterval === 'manual'">
          <span v-html="'&nbsp;'" />
          <app-i18n code="subpropertySettings.finantial.payoutSchedule.cardFrequency.placeholders.manual" />
        </template>

        <template v-else>
          <span v-html="'&nbsp;'" />
          <app-i18n code="subpropertySettings.finantial.payoutSchedule.cardFrequency.placeholders.automatic" />
          <span v-html="' - '" />
          <app-i18n :code="`enumerators.stripePayoutsScheduleInterval.${payoutsScheduleInterval}`" />
          <template v-if="payoutsScheduleAnchorI18nCode">
            <span v-html="'&nbsp;('" />
            <app-i18n :code="payoutsScheduleAnchorI18nCode" />
            <span v-html="')'" />
          </template>
        </template>

        <custom-link 
          :linkTo="routeToPayouts"
          :contentText="i18n('entities.wallet.links.payouts')"
        />
      </div>
    </div>

    <!-- Balances -->
    <el-container class="stripe-wallet-widget__balance__container">
      <app-stripe-balance-widget
        v-if="subpropertyId"
        :subpropertyId="subpropertyId"
      />
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StripePayoutListTable from '@modules/stripe/stripe-payout/components/stripe-payout-list-table.vue';
import StripeBalanceWidget from '@modules/stripe/stripe-balance/components/stripe-balance-widget.vue';
import { i18n } from '@shared/i18n';
export default {
  name: 'app-stripe-wallet-widget',
  data() {
    return {
      routeToPayouts: {
        name: 'stripeIncome',
        params: {
          tabName: 'payouts'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      connectedAccount: 'stripeBalance/list/connectedAccount'
    }),
    manageLogoUrl() {
      if (!this.currentManage) return null;
      if (
        this.currentManage.property &&
        this.currentManage.property.logos &&
        this.currentManage.property.logos.length > 0
      ) {
        return `url("${this.currentManage.property.logos[0].publicUrl}")`;
      }
      return null;
    },
    propertyId() {
      return this.currentManage.property.id;
    }, 
    subpropertyId() {
      return this.currentManage.subproperty.id; 
    },
    payoutsScheduleInterval() {
      if (this.connectedAccount && this.connectedAccount.settings) {
        return this.connectedAccount.settings.payoutsScheduleInterval;
      }
      return null;
    },
    payoutsScheduleAnchorI18nCode() {
      const { settings } = this.connectedAccount
      switch (this.payoutsScheduleInterval) {
        case 'weekly':
          return `enumerators.weekDay.${settings.payoutsScheduleWeeklyAnchor}`
        case 'monthly':
          return `enumerators.monthDay.${settings.payoutsScheduleMonthlyAnchor}`
        default:
          return null
      }
    },
  },
  methods: {
    ...mapActions({
      doPayout: 'stripeBalance/list/doPayout'
    }), 
    ...{ i18n }
  }, 
  components: {
    [StripePayoutListTable.name]: StripePayoutListTable,
    [StripeBalanceWidget.name]: StripeBalanceWidget,
  },
};
</script>

<style lang="scss" scoped>
.stripe-wallet-widget {
  --image-width: 50px;

  background: #fff;
  overflow-y: hidden;
  padding: 32px 48px;
  flex-direction: column;

  &__header {
    display: grid;
    grid-template-columns: var(--image-width) 1fr auto;
    grid-template-areas: 'image title payout';
    grid-gap: 16px;

    font-size: 14px;
    color: #606266;

    &__image {
      grid-area: image;

      max-width: 100%;
      width: var(--image-width);
      height: var(--image-width);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border-radius: 100%;
    }

    &__title {
      grid-area: title;
      align-self: center;

      display: grid;
      grid-gap: 4px;

      &__property {
        font-size: 14px;
        font-weight: normal;
        color: #606266;
      }

      &__subproperty {
        font-size: 22px;
        font-weight: 500;
        color: #606266;
      }
    }

    &__payout {
      grid-area: payout;

      font-size: 14px;
      font-weight: 500;
      text-align: right;
      color: #404040;

      &__title {
        font-weight: 300;
      }
    }
  }

  &__balance__container,
  &__activity__container {
    flex-direction: column;
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    margin-top: 32px;
    padding: 32px 24px;
  }
}
</style>
